export const getRandomInt = (min: number, max: number): number => (
    Math.floor(Math.random() * (max - min + 1)) + min
)

export const rand = () => getRandomInt(1, 6)
